const Vue = require('vue');
const { createApp, ref, computed } = Vue;

createApp({
  setup() {
    const mode = ref('in');
    const ventilation = ref('12');
    const humidity = ref('70');
    const illumination = ref('70');
    const timer = ref('15');

    const description = computed(() => {
      const key = `${mode.value}${ventilation.value}${humidity.value}${illumination.value}${timer.value}`;
      return window.pageConfigurator__description[key] || null;
    });

    const schema = computed(() => {
      const key = `${mode.value}${ventilation.value}${humidity.value}${illumination.value}${timer.value}`;
      return window.pageConfigurator__schema[key] || null;
    });

    return {
      mode,
      ventilation,
      humidity,
      illumination,
      timer,
      description,
      schema,
    };
  },
}).mount('#vue-page-configurator');
